module.exports = "<div class=\"slide-selector\">\n\t<div class=\"slide-selector__wrapper\" :class=\"{ 'is-open': isOpen }\" v-on-clickaway=\"slideUp\">\n\t\t<a :href=\"item.url\" class=\"slide-selector__item\" :class=\"{ 'is-selected': item.active, 'slide-selector__item--revealed': isOpen  }\" v-for=\"item in items\" @click.prevent=\"slideDown( item )\">\n\t\t\t<span class=\"slide-selector__item-inner\">{{ item.code }}</span>\n\t\t</a>\n\t</div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./assets/_js/components/slide-selector/slide-selector.vhtml
// module id = 313
// module chunks = 0